/**
 * Layout component for login/auth pages
 * Scrollable on short viewports; top padding leaves room for floating logo
 */
export default function LoginLayout({ children }) {
  return (
    <div
      className="
        min-h-dvh w-full
        flex items-start justify-center
        overflow-x-hidden overflow-y-auto
        px-3 py-6 pt-14
        sm:px-4 sm:py-8 sm:pt-16
        md:px-6 md:items-center md:py-10 md:pt-16
        login-layout-bg
      "
      style={{ WebkitOverflowScrolling: "touch" }}
    >
      <div className="w-full max-w-md my-auto">{children}</div>
    </div>
  );
}
